// rootReducer.js

import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./slices/user";

/**
 * @typedef {Object} RootState - The root state object.
 * @property {ServiceState} service - The category slice state.
 */

export default combineReducers({
  user: userReducer,
});
